import PropTypes from 'prop-types';

export const BoxPropTypes = {
  active: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.string,
    PropTypes.node,
  ]),
  fullwidth: PropTypes.bool,
  fullwidth2: PropTypes.bool,
  left: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.node]),
  leftColProps: PropTypes.object,
  right: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.string,
    PropTypes.node,
  ]),
  rightColProps: PropTypes.object,
  stickyContainer: PropTypes.bool,
  withoutBorder: PropTypes.bool,
};

export const BoxDefaultProps = {
  active: false,
  children: null,
  left: null,
  leftColProps: {},
  right: null,
  rightColProps: {},
  stickyContainer: false,
  withoutBorder: false,
};
